import { PermissionEnum } from '@Application/Security/Roles';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@verclam/ui-kit';

/** Leaf action: opens the empty group editor. */
const NewDocumentGroupButton: React.FC = () => {
	const navigate = useNavigate();

	const handleClick = React.useCallback(() => {
		navigate('/administration/document-groups/new');
	}, [navigate]);

	return (
		<WithPermission permission={PermissionEnum.ORGANIZATION_WRITE}>
			<Button type="button" label="Nouveau groupe" icon={<Plus size={16} />} onClick={handleClick} />
		</WithPermission>
	);
};

export default NewDocumentGroupButton;
